import React from 'react';
import './StarlinkTestimonials.scss';

const StarlinkTestimonials: React.FC = () => {
  const testimonials = [
    {
      name: "David Martinez",
      role: "Fleet Operations Manager",
      image: "👨💼",
      rating: 5,
      text: "Starlink transformed our 50-vehicle fleet management. Driver behavior monitoring alone saved us 30% on insurance. The hardwired installation means zero tampering."
    },
    {
      name: "Lisa Anderson",
      role: "Construction Company CEO",
      image: "👷‍♀️",
      rating: 5,
      text: "Managing equipment across 12 job sites was chaos. Starlink's real-time tracking and geofencing alerts have eliminated unauthorized use. ROI in 6 months."
    },
    {
      name: "Robert Chen",
      role: "Logistics Director",
      image: "🚚",
      rating: 5,
      text: "Route optimization and fuel tracking features paid for themselves in the first quarter. The 365 Trac platform is intuitive and our drivers adapted quickly."
    },
    {
      name: "Jennifer Williams",
      role: "Transportation Manager",
      image: "👩💼",
      rating: 5,
      text: "Professional installation was seamless across our entire fleet. The dual protection with backup tracking gives us complete peace of mind. Highly recommend for any fleet."
    }
  ];

  return (
    <section className="starlink-testimonials">
      <div className="container">
        <h2>Trusted by Fleet Managers</h2>
        <p className="subtitle">See how Starlink is transforming fleet operations</p>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className="star">⭐</span>
                ))}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="testimonial-author">
                <div className="author-avatar">{testimonial.image}</div>
                <div className="author-info">
                  <div className="author-name">{testimonial.name}</div>
                  <div className="author-role">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StarlinkTestimonials;
